<template>
    <master-page>
        <br/>
        <v-card>
            <v-card-title style="background: var(--v-primary-base); position: sticky; top: 75px; z-index: 1; color: white !important">
                <v-icon large left style="color: white">mdi-chart-areaspline</v-icon>
                <span class="title font-weight-light">Configuração do Detalhamento dos Projetos</span>
                <v-spacer/>
                <v-tooltip bottom>
                    <template v-slot:activator="{ on }">
                        <v-btn fab small depressed="" color="primary" class="mr-2" @click="GerarRelatorio()" v-on="on"><v-icon>mdi-text-box-check</v-icon></v-btn>
                    </template>
                    <span>Gerar Relatório</span>
                </v-tooltip>
                <v-tooltip bottom>
                    <template v-slot:activator="{ on }">
                        <v-btn fab small depressed="" color="primary" class="mr-2" @click="LimparFiltros()" v-on="on"><v-icon>mdi-eraser</v-icon></v-btn>
                    </template>
                    <span>Limpar</span>
                </v-tooltip>
            </v-card-title>
            <v-card-text class="mt-3">
                <v-form id="form" ref="form" v-model="valid" lazy-validation>
                    <v-row dense>
                        <v-col cols="12" sm="6" md="6">
                            <v-autocomplete v-model="filtro.projetoId" :items="projetos" :loading="isProjetoLoading" :search-input.sync="onSearchProjeto" clearable
                                item-text="codigoNome" item-value="id" label="Projeto" :rules="fieldRules" dense outlined/>
                        </v-col>
                        <v-col cols="12" sm="6" md="6">
                            <v-select v-model="filtro.layoutId" label="Layout" :items="layouts" item-value="key" item-text="value" dense outlined @change="AlterarLayout()"/>
                        </v-col>                                        
                    </v-row>
                    <v-row v-if="filtro.layoutId != 4" dense>
                        <!-- DATA PAGAMENTO -->
                        <v-col cols="12" sm="6" md="3">
                            <v-menu :close-on-content-click="false" transition="scale-transition" offset-y min-width="290px" max-width="290px">
                                <template v-slot:activator="{on}">
                                    <v-text-field type="date" v-model="filtro.dataInicio" label="Data Pagamento (Inicial)" dense outlined :disabled="filtro.layoutId == 1" :rules="filtro.layoutId == 4 ? fieldRules : []">
                                        <template v-slot:prepend>
                                            <v-icon v-on="on">mdi-calendar</v-icon>
                                        </template>
                                    </v-text-field>
                                </template>
                                <v-date-picker locale="pt-br" v-model="filtro.dataInicio" no-title/>
                            </v-menu>
                        </v-col>
                        <v-col cols="12" sm="6" md="3">
                            <v-menu :close-on-content-click="false" transition="scale-transition" offset-y min-width="290px" max-width="290px">
                                <template v-slot:activator="{on}">
                                    <v-text-field type="date" v-model="filtro.dataTermino" label="Data Pagamento (Final)" dense outlined :disabled="filtro.layoutId == 1 || filtro.layoutId == 4">
                                        <template v-slot:prepend>
                                            <v-icon v-on="on">mdi-calendar</v-icon>
                                        </template>
                                    </v-text-field>
                                </template>
                                <v-date-picker locale="pt-br" v-model="filtro.dataTermino" no-title/>
                            </v-menu>
                        </v-col>
                        <!-- DATA EMISSAO -->
                        <v-col cols="12" sm="6" md="3">
                            <v-menu :close-on-content-click="false" transition="scale-transition" offset-y min-width="290px" max-width="290px">
                                <template v-slot:activator="{on}">
                                    <v-text-field type="date" v-model="filtro.emissaoInicial" label="Data Emissão (Inicial)" dense outlined :disabled="filtro.layoutId != 3">
                                        <template v-slot:prepend>
                                            <v-icon v-on="on">mdi-calendar</v-icon>
                                        </template>
                                    </v-text-field>
                                </template>
                                <v-date-picker locale="pt-br" v-model="filtro.emissaoInicial" no-title/>
                            </v-menu>
                        </v-col>
                        <v-col cols="12" sm="6" md="3">
                            <v-menu :close-on-content-click="false" transition="scale-transition" offset-y min-width="290px" max-width="290px">
                                <template v-slot:activator="{on}">
                                    <v-text-field type="date" v-model="filtro.emissaoFinal" label="Data Emissão (Final)" dense outlined :disabled="filtro.layoutId != 3">
                                        <template v-slot:prepend>
                                            <v-icon v-on="on">mdi-calendar</v-icon>
                                        </template>
                                    </v-text-field>
                                </template>
                                <v-date-picker locale="pt-br" v-model="filtro.emissaoFinal" no-title/>
                            </v-menu>
                        </v-col>
                        <!-- DATA COMPETENCIA -->
                        <v-col cols="12" sm="6" md="3">
                            <v-menu :close-on-content-click="false" transition="scale-transition" offset-y min-width="290px" max-width="290px">
                                <template v-slot:activator="{on}">
                                    <v-text-field type="date" v-model="filtro.competenciaInicial" label="Data Competência (Inicial)" dense outlined :disabled="filtro.layoutId != 3">
                                        <template v-slot:prepend>
                                            <v-icon v-on="on">mdi-calendar</v-icon>
                                        </template>
                                    </v-text-field>
                                </template>
                                <v-date-picker locale="pt-br" v-model="filtro.competenciaInicial" no-title/>
                            </v-menu>
                        </v-col>
                        <v-col cols="12" sm="6" md="3">
                            <v-menu :close-on-content-click="false" transition="scale-transition" offset-y min-width="290px" max-width="290px">
                                <template v-slot:activator="{on}">
                                    <v-text-field type="date" v-model="filtro.competenciaFinal" label="Data Competência (Final)" dense outlined :disabled="filtro.layoutId != 3">
                                        <template v-slot:prepend>
                                            <v-icon v-on="on">mdi-calendar</v-icon>
                                        </template>
                                    </v-text-field>
                                </template>
                                <v-date-picker locale="pt-br" v-model="filtro.competenciaFinal" no-title/>
                            </v-menu>
                        </v-col>
                        <v-col cols="6" sm="2" md="2">
                            <v-switch v-model="filtro.exibirBeneficiarios" label="Exibir Beneficiários" style="margin-top: -5px" :disabled="filtro.layoutId != 1"/>
                        </v-col>
                        <v-col cols="6" sm="2" md="2">
                            <v-switch v-model="filtro.exibirColaboradores" label="Exibir Colaboradores" style="margin-top: -5px" :disabled="filtro.layoutId != 1"/>
                        </v-col>  
                    </v-row>
                    <v-row v-else dense>
                        <v-col cols="12" sm="2" style="margin-top: -15px;">
                            <v-switch v-model="dataValidade" :label="dataValidade ? 'Data Pagamento' : 'Data Competencia'" dense hide-details/>
                        </v-col>
                        <!-- DATA PAGAMENTO -->
                        <v-col cols="12" sm="5">
                            <v-menu :close-on-content-click="false" transition="scale-transition" offset-y min-width="290px" max-width="290px">
                                <template v-slot:activator="{on}">
                                    <v-text-field type="date" v-model="filtro.dataInicio" label="Data Pagamento (Inicial)" dense outlined :disabled="!dataValidade">
                                        <template v-slot:prepend>
                                            <v-icon v-on="on">mdi-calendar</v-icon>
                                        </template>
                                    </v-text-field>
                                </template>
                                <v-date-picker locale="pt-br" v-model="filtro.dataInicio" no-title/>
                            </v-menu>
                        </v-col>
                        <!-- DATA COMPETENCIA -->
                        <v-col cols="12" sm="5">
                            <v-menu :close-on-content-click="false" transition="scale-transition" offset-y min-width="290px" max-width="290px">
                                <template v-slot:activator="{on}">
                                    <v-text-field type="date" v-model="filtro.competenciaInicial" label="Data Competência (Inicial)" dense outlined :disabled="dataValidade">
                                        <template v-slot:prepend>
                                            <v-icon v-on="on">mdi-calendar</v-icon>
                                        </template>
                                    </v-text-field>
                                </template>
                                <v-date-picker locale="pt-br" v-model="filtro.competenciaInicial" no-title/>
                            </v-menu>
                        </v-col>
                    </v-row>
                </v-form>           
            </v-card-text>
        </v-card>
    </master-page>
</template>

<script>
import { ProjetoService } from '../../../core/services/projetos';

export default {
    data: () => ({
        dataValidade: true,
        filtro: {
            projetoId: 0,
            dataInicio: null,
            dataTermino: null,
            emissaoInicial: null,
            emissaoFinal: null,
            competenciaInicial: null,
            competenciaFinal: null,
            exibirBeneficiarios: false,
            exibirColaboradores: false,
            layoutId: 1
        },
        layouts: [
            {
                key:1,
                value:"Detalhado"
            },
            {
                key:2,
                value:"Detalhado + Despesas"
            },
            {
                key:3,
                value:"Prestação de Contas"
            },
            {
                key:4,
                value:"Previsto x Realizado"
            },
        ],
        projetoService: new ProjetoService(),
        projetos: [],        
        isProjetoLoading: false,
        onSearchProjeto: null,
        valid: true,
        fieldRules: [
            v => !!v || 'Campo obrigatório'
        ]
    }),
    methods: {
        GerarRelatorio(){
            if( this.$refs.form.validate() && this.VerificaPreenchimentoLayout4()){
                this.AbrirJanela('relatorioDetalhamentoProjetos');
            }
        },
        LimparFiltros(){
            this.filtro = {
                projetoId: 0,
                exibirBeneficiarios: false,
                exibirColaboradores: false,
                layoutId: 1
            }
            this.projetos = []
        },
        AbrirJanela(rota) {
            let routeLink = this.$router.resolve({ name: rota,
                query:{
                    dataInicio: this.filtro.dataInicio,
                    dataTermino: this.filtro.dataTermino,
                    emissaoInicial: this.filtro.emissaoInicial,
                    emissaoFinal: this.filtro.emissaoFinal,
                    competenciaInicial: this.filtro.competenciaInicial,
                    competenciaFinal: this.filtro.competenciaFinal,
                    projetoId: this.filtro.projetoId,                    
                    exibirBeneficiarios: this.filtro.exibirBeneficiarios,
                    exibirColaboradores: this.filtro.exibirColaboradores,                    
                    layoutId: this.filtro.layoutId
                } 
            });
            window.open(routeLink.href,'_blank');
        }, 
        AlterarLayout(){
            if(this.filtro.layoutId != 1){
                this.filtro.exibirBeneficiarios = false,
                this.filtro.exibirColaboradores = false
            }
            else if(this.filtro.layoutId == 1){
                this.filtro.dataInicio = '',
                this.filtro.dataTermino = ''
            }
        },
        VerificaPreenchimentoLayout4(){

            if(this.filtro.layoutId == 4 && !this.filtro.dataInicio && !this.filtro.competenciaInicial){
                this.$swal('Aviso', "Pelo menos uma das datas devem estar preenchidas!", 'warning')
                return false;
            }
            return true;
            
        }
    },
    watch:{
        dataValidade(){
            this.filtro.dataInicio = null,
            this.filtro.competenciaInicial = null
        },
        onSearchProjeto(val){
            if(this.isProjetoLoading) return;
            if(this.filtro.projetoId) return;
            if(!val) return;

            this.isProjetoLoading = true;
            this.projetoService.AutoComplete(val)
            .then(
                res=>{
                    this.projetos = res.data
                },
                err => this.$swal('Aviso', err.response.data, 'error')
            )
            .finally(() => (this.isProjetoLoading = false))
        },
        'filtro.layoutId': {
            handler : function () {
                if(this.filtro.layoutId != 3){
                    this.filtro.emissaoInicial = null
                    this.filtro.emissaoFinal = null
                    this.filtro.competenciaInicial = null
                    this.filtro.competenciaFinal = null
                }
            }
        }
    },
    mounted(){    

    }
}

</script>